import { ApiError } from "./api";
import type { StatusVariant } from "../components/StatusLine";

const RUNNING_MSG = "Running… (may take several minutes, do not close the tab)";

interface MutationLike {
  isPending: boolean;
  isSuccess: boolean;
  isError: boolean;
  error: Error | null;
}

export function statusFromMutation(m: MutationLike): {
  variant: StatusVariant;
  message: string;
} {
  if (m.isPending) return { variant: "running", message: RUNNING_MSG };
  if (m.isSuccess) return { variant: "success", message: "Done" };
  if (m.isError && m.error) {
    if (m.error instanceof ApiError) {
      return { variant: "error", message: m.error.message };
    }
    return { variant: "error", message: `Network error: ${m.error.message}` };
  }
  return { variant: "idle", message: "" };
}

export function errorPayload(err: Error | null): unknown {
  if (err instanceof ApiError) return err.payload;
  return { error: err?.message ?? "unknown" };
}
